import { saveAs } from "file-saver";

import { Dates, ExportMethod, FileExporter, TableFormat, Tables, Translations } from "@salaxy/core";
import { AlertService } from "./AlertService";
import { ExcelHelpers } from "./ExcelHelpers";
import angular from "angular";

/**
 * Provides functionality related to working with files: Download, copy-paste etc.
 */
export class FileService {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["AlertService", "$timeout"];

  constructor(private alertService: AlertService, private $timeout: angular.ITimeoutService) {
    // Dependency injection
  }

  /** Copies given data to the clipboard. */
  public copyToClipboard(data: string): Promise<void> {
    return (navigator as any).clipboard.writeText(data).then(() => {
      return this.$timeout(() => {
        return;
      });
    });
  }

  /** Gets the default exporters available in the current environment / account  */
  public getDefaultExporters(): FileExporter[] {
    return [
      {
        id: ExportMethod.CopyExcel,
        label: Translations.get("SALAXY.NG1.ODataActionsComponent.getDefaults.copyExcel"),
        hasLocales: true,
        export: (rows, locale) => {
          const tabbedData = Tables.export(rows as any, TableFormat.Txt, locale);
          this.copyToClipboard(tabbedData);
          this.alertService.addSuccess(`${rows.length} ${Translations.get("SALAXY.NG1.ExportComponent.export.rowsCopiedOnClipboard")}`);
        }
      },
      {
        id: ExportMethod.FileExcel,
        label: Translations.get("SALAXY.NG1.ODataActionsComponent.getDefaults.fileExcel"),
        hasLocales: false,
        export: (rows) => {
          return ExcelHelpers.export(Tables.exportAsArrays(rows as any), this.getFileName());
        }
      },
      {
        id: ExportMethod.CopyCsv,
        label: Translations.get("SALAXY.NG1.ODataActionsComponent.getDefaults.copyCsv"),
        hasLocales: true,
        export: (rows, locale) => {
          const csvData = Tables.export(rows as any, TableFormat.Csv, locale);
          this.copyToClipboard(csvData);
          this.alertService.addSuccess(`${rows.length} ${Translations.get("SALAXY.NG1.ExportComponent.export.rowsCopiedOnClipboard")}`);
        }
      },
      {
        id: ExportMethod.FileCsv,
        label: Translations.get("SALAXY.NG1.ODataActionsComponent.getDefaults.fileCsv"),
        hasLocales: true,
        export: (rows, locale) => {
          const csvFileData = Tables.export(rows as any, TableFormat.Csv, locale);
          saveAs(new Blob([csvFileData], { type: "application/octet-stream;charset=utf-8" }), `${this.getFileName()}.csv`);
        }
      }
    ];
  }

  /** Gets a filename as ¨export_[YYYYMMDD]¨. */
  private getFileName() {
    return `export_${Dates.format("today", "YYYYMMDD")}`;
  }

}